module.exports = __webpack_public_path__ + "img/shitouji.9e6cbc09.jpg";